export default __webpack_public_path__ + "static/media/icon_thongke.d7672249.svg";